<template lang="pug">
section.section(
    :class="classes"
    @click="editSection"
)
    include /components/Page/Sections/base.pug
    //- .content-wrappers.evaluation(v-if="!isEmpty || getInformations(section).length || $slots.default")
    //-     slot
    //-     .preview
    //-         // TODO
    .content-wrappers.evaluation(v-if="$slots.default")
        slot
    el-drawer.full-height-drawer.visible-overflow(
        v-if="editable"
        :title="$t('Edit {section}', { section: section.name })"
        :visible.sync="scopedUI.form"
        :close-on-press-escape="true"
        :wrapper-closable="false"
        :append-to-body="true"
        size="920px"
        :modal="true"
        @closed="resetDrawer"
    )
        .drawer-body(v-loading="drawer.loading")
            el-tabs(
                v-if="!drawer.loading"
                v-model="drawer.tab"
                tab-position="top"
            )
                el-tab-pane(name="content" :label="$t('Content')")
                    .tab-content(v-if="contents && contents.length")
                        transition-group(name="slide-vertical")
                            .content-wrapper.information-row(
                                v-if="informations.length"
                                v-for="information in informations"
                                :key="information.id"
                            )
                                .button-row.insert-row
                                    el-button.section-option.insert-information(
                                        v-if="edit"
                                        type="primary"
                                        size="mini"
                                        @click.stop="insertInformation('information-content', information.position)"
                                        icon="el-icon-fa-pen fas"
                                    )
                                    el-button.section-option.insert-information(
                                        v-if="edit"
                                        type="primary"
                                        size="mini"
                                        @click.stop="insertInformation('information-image', information.position)"
                                        icon="el-icon-fa-file-image fas"
                                    )
                                Information(
                                    :key="information.id"
                                    :section="drawer.section"
                                    :information="information"
                                    :config="defaultConfig"
                                    :options="options"
                                    :section-setting-values="settingValues"
                                    :edit="true"
                                )
                        .button-row
                            el-button.section-option.add-information(
                                v-if="edit"
                                type="primary"
                                size="mini"
                                @click.stop="addInformation('information-content')"
                                icon="el-icon-fa-plus fas"
                            ) {{ $t('Insertion') }}
                            el-button.section-option.add-information(
                                v-if="edit"
                                type="primary"
                                size="mini"
                                @click.stop="addInformation('information-image')"
                                icon="el-icon-fa-file-image fas"
                            ) {{ $t('Image') }}
                el-tab-pane(name="settings" :label="$t('Settings')")
                    .block-settings
                        .settings-wrap
                            include /components/Page/Sections/settings.pug
        .drawer-footer
            include /components/Page/Sections/section-drawer-footer.pug
</template>

<i18n>
{
    "en": {
        "Edit {section}": "Edit {section}"
    },
    "de": {
        "Edit {section}": "{section} bearbeiten",
        "Content": "Inhalt",
        "Settings": "Einstellungen",
        "Insertion": "Einblendung",
        "Image": "Bild",
        "from": "ab",
        "to": "bis",
        "Margin top": "Abstand oben",
        "Margin bottom": "Abstand unten",
        "none": "Ohne",
        "small": "Klein",
        "medium": "Mittel",
        "large": "Groß",
        "default": "Standard",
        "custom": "Benutzerdefiniert",
        "e.g. 40px, 10%, 2em, ...": "z.B. 40px, 10%, 2em, ..."
    }
}
</i18n>

<script>
import _ from 'lodash'
import uniqid from 'uniqid';

import store from '@/store'

import { addContentToSection } from '@/helpers'

import Information from './Information'
import Reaction from './Reaction'
import Section from '../../Section'

export default {
    name: 'Evaluation',
    extends: Section,
    components: {
        Information,
        Reaction,
    },
    computed: {
        editable() {
            return true;
        },
        informations: {
            get() {
                const section = this.drawer.section || this.section
                return this.getInformations(section)
            },
            set(informations) {
                // NOTE: this is not used
                // ment to handle drag 'n drop

                // const i = this.i

                // const section = this.drawer.section || this.section

                // // get index of the one section without id
                // const s = _.findIndex(informations, information => information.id === undefined)

                // if (s >= 0) {
                //     let information = _.cloneDeep(informations[s])
                //     information.area = this.key

                //     setTimeout(() => store.commit(`${this.module}/form/addInformation`, { i, s, information }), 300);
                // }
            },
        },
    },
    methods: {
        getInformations(section) {
            let informations = _.get(section, 'informations') || []
            informations = informations.sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))

            return informations
        },
        addInformation(type = 'information-content', position = undefined) {
            const section = this.drawer.section || this.section

            const informations = _.get(section, 'informations');
            if (informations === undefined) this.$set(section, 'informations', []);

            if (position === undefined) position = section.informations.length + 1;

            const information = {
                id: uniqid('new:'),
                position,
                contents: [],
                reactions: []
                // initialPosition: informations.length
            };

            let configs = _.get(this.defaultConfig, 'contents') || [];
            configs = configs.filter(el => el.scope === 'information');

            if (configs.length) {
                configs
                    .sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
                    .forEach(config => {
                        if (config.key === type) {
                            let content = {
                                id: uniqid('new:'),
                                key: config.key,
                            };

                            addContentToSection(information, config, content)
                        }
                    });
            }

            this.$set(section.informations, section.informations.length, information);
        },
        insertInformation(type = 'information-content', position = 0) {
            const section = this.drawer.section || this.section

            const informations = _.get(section, 'informations') || [];

            let contents = [];
            informations.forEach((information, index) => {
                if (information.position >= position) informations[index].position += 1;
            });

            this.addInformation(type, position)
        },
    }
}
</script>

<style lang="sass" scoped>
.button-row
    margin-bottom: 1rem

.slide-vertical-enter-active, .slide-vertical-leave-active
    transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease
    // transform-origin: left center
    max-height: 900px
    overflow: hidden
.slide-vertical-enter, .slide-vertical-leave-to
    opacity: 0
    max-height: 0
    transform: translateY(-30px)
    // transform: scale(0.5)
</style>
